import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
} from 'Shared/img/guidelineForCurators'

import {
  TextContainer,
  Text,
  List,
  ListItem,
  Paragraph,
  SubTitle,
  SubTitleContainer,
} from './styles'

export const useSlidesContent = () => {
  const { t } = useTranslation()

  const slides = [
    {
      id: 1,
      img: image1,
      title: t('termsAndConditions.title1'),
      content: (
        <TextContainer edge>
          <Text>{t('termsAndConditions.text1-1')}</Text>
          <Text>{t('termsAndConditions.text1-2')}</Text>
          <Text orange>{t('termsAndConditions.text1-3')}</Text>
        </TextContainer>
      ),
    },
    {
      id: 2,
      img: image2,
      title: t('termsAndConditions.title2'),
      content: (
        <TextContainer>
          <Text>{t('termsAndConditions.text2-1')}</Text>
          <List marginTop>
            <ListItem>{t('termsAndConditions.list2-1')}</ListItem>
            <ListItem>{t('termsAndConditions.list2-2')}</ListItem>
            <ListItem>{t('termsAndConditions.list2-3')}</ListItem>
          </List>
        </TextContainer>
      ),
    },
    {
      id: 3,
      img: image3,
      title: t('termsAndConditions.title3'),
      content: (
        <TextContainer>
          <Text>{t('termsAndConditions.text3-1')}</Text>
          <List marginTop>
            <ListItem>{t('termsAndConditions.list3-1')}</ListItem>
            <ListItem>{t('termsAndConditions.list3-2')}</ListItem>
            <ListItem>{t('termsAndConditions.list3-3')}</ListItem>
            <ListItem>{t('termsAndConditions.list3-4')}</ListItem>
            <ListItem>{t('termsAndConditions.list3-5')}</ListItem>
            <ListItem>{t('termsAndConditions.list3-6')}</ListItem>
            <ListItem>{t('termsAndConditions.list3-7')}</ListItem>
          </List>
        </TextContainer>
      ),
    },
    {
      id: 4,
      img: image4,
      title: t('termsAndConditions.title4'),
      content: (
        <TextContainer>
          <Paragraph>
            <Text monospace>{t('termsAndConditions.text4-1')}</Text>
          </Paragraph>
          <List marginTop>
            <ListItem>{t('termsAndConditions.list4-1')}</ListItem>
            <ListItem>{t('termsAndConditions.list4-2')}</ListItem>
            <ListItem>{t('termsAndConditions.list4-3')}</ListItem>
            <ListItem>{t('termsAndConditions.list4-4')}</ListItem>
            <ListItem>{t('termsAndConditions.list4-5')}</ListItem>
          </List>
        </TextContainer>
      ),
    },
    {
      id: 5,
      img: image5,
      title: t('termsAndConditions.title5'),
      content: (
        <TextContainer>
          <Paragraph>
            <Text monospace>{t('termsAndConditions.text5-1')}</Text>
            <Text monospace bold>
              {t('termsAndConditions.text5-2')}
            </Text>
            <Text monospace>{t('termsAndConditions.text5-3')}</Text>
          </Paragraph>
          <Paragraph>
            <Text monospace>{t('termsAndConditions.text5-4')}</Text>
            <Text monospace bold>
              {t('termsAndConditions.text5-5')}
            </Text>
          </Paragraph>
          <Paragraph>
            <Text monospace>{t('termsAndConditions.text5-6')}</Text>
            <Text monospace bold>
              {t('termsAndConditions.text5-7')}
            </Text>
          </Paragraph>
        </TextContainer>
      ),
    },
    {
      id: 6,
      img: image6,
      title: t('termsAndConditions.title6'),
      content: (
        <TextContainer edge>
          <Text>{t('termsAndConditions.text6-1')}</Text>
        </TextContainer>
      ),
    },
    {
      id: 7,
      img: image7,
      content: (
        <SubTitleContainer>
          <SubTitle>{t('termsAndConditions.subTitle7')}</SubTitle>
        </SubTitleContainer>
      ),
    },
  ]
  return {
    slides,
  }
}
